import { withdrawBiddingSpotBid } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'

import { spotApprovalRequestInvalidationKeys } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 入札中の札 1 枚の取下 mutation hook (AC-BSP-057)。
 *
 * 対象は申請セットではなく**札 1 枚**だが、楽観ロックの基準はその札が属する
 * 申請セットの updated_at (= backend が集約単位で書き込むため)。
 *
 * 成功しても札が「取消」になるとは限らない: JEPX への取消送信は非同期で、
 * 成立するまで札は「取下処理中」に留まる (AC-BSP-057b)。onSuccess の
 * invalidate で最新状態を取り直す。
 */
export function useWithdrawBiddingSpotBid(): InvalidatingMutationResultFor<
  typeof withdrawBiddingSpotBid
> {
  return useWorkflowCaseScopedMutation(
    useInvalidatingMutation(
      withdrawBiddingSpotBid,
      spotApprovalRequestInvalidationKeys,
    ),
  )
}
